import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/QRcode.jpg'


const _hoisted_1 = { id: "user-login" }

import { reactive, ref, onUnmounted } from "vue";
import { SmsControllerService, UserControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { IconEmail, IconLock, IconUser } from "@arco-design/web-vue/es/icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserLoginView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const isVerityButtonDisabled = ref(false);
const coldDownTime = ref(60);
// 倒计时定时器 id
const cooldownTimer = ref<number | null>(null);
const formAccPass = reactive({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
} as any);
const formVerity = reactive({
  userMail: "",
  verityCode: "",
});

const trueCode = ref("654321");
const formRef = ref(null);
const verityCodeProps = ref({
  disabled: false,
  error: false,
  answer: "aaaaaa",
});
const getCode = async () => {
  if (!formVerity.userMail || formVerity.userMail === "") {
    message.error("请输入邮箱！");
  }
  // 启动倒计时：每秒递减 coldDownTime，直到 0
  if (cooldownTimer.value) {
    clearInterval(cooldownTimer.value);
    cooldownTimer.value = null;
  }
  isVerityButtonDisabled.value = true;
  coldDownTime.value = 60;
  cooldownTimer.value = window.setInterval(() => {
    if (coldDownTime.value <= 1) {
      // 倒计时结束
      if (cooldownTimer.value) {
        clearInterval(cooldownTimer.value);
        cooldownTimer.value = null;
      }
      isVerityButtonDisabled.value = false;
      coldDownTime.value = 60;
    } else {
      coldDownTime.value -= 1;
    }
  }, 1000);
  const res = await SmsControllerService.sendMailRegisterUsingPost(formVerity);
  if (res.code === 0) {
    // 获取到验证码
    trueCode.value = res.data;
  }
};

onUnmounted(() => {
  if (cooldownTimer.value) {
    clearInterval(cooldownTimer.value);
    cooldownTimer.value = null;
  }
});
const onFinish = (value: any) => {
  if (value !== trueCode.value) {
    verityCodeProps.value.error = true;
    message.error("验证码错误！");
    formVerity.verityCode = "";
  } else {
    verityCodeProps.value.error = false;
    verityCodeProps.value.disabled = true;
  }
};
const handleSubmit = async () => {
  const redirectUrl = window.location.search;
  const res = await UserControllerService.userLoginUsingPost(formAccPass);
  if (res.code === 0) {
    await store.dispatch("user/getLoginUser");
    // 登录成功跳转页面
    // 重定向
    if (redirectUrl.startsWith("?redirect=")) {
      await router.push({
        path: redirectUrl.split("?redirect=")[1],
        replace: true,
      });
    } else {
      // 主页
      await router.push({
        path: "/",
        replace: true,
      });
    }
  } else {
    message.error("登录失败" + res.message);
  }
};
const handleSubmitVerity = async () => {
  const redirectUrl = window.location.search;
  const res = await UserControllerService.userLoginWithVerityUsingPost(
    formVerity
  );
  if (res.code === 0) {
    await store.dispatch("user/getLoginUser");
    // 登录成功跳转页面
    // 重定向
    if (redirectUrl.startsWith("?redirect=")) {
      await router.push({
        path: redirectUrl.split("?redirect=")[1],
        replace: true,
      });
    } else {
      // 主页
      await router.push({
        path: "/",
        replace: true,
      });
    }
  } else {
    message.error("登录失败" + res.message);
  }
};
const rulesAccPass = {
  userAccount: [
    {
      required: true,
      message: "请输入用户名！",
    },
  ],
  userPassword: [
    {
      required: true,
      message: "请输入密码！",
    },
  ],
};
const rulesVerity = {
  userMail: [
    {
      type: "email",
      required: true,
      message: "请输入邮箱！",
    },
  ],
  verityCode: [
    {
      required: true,
      message: "请输入验证码！",
    },
    {
      minLength: 6,
      message: "验证码未填完全！",
    },
    {
      match: /^\d+$/,
      message: "应为全数字！",
    },
  ],
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_verification_code = _resolveComponent("a-verification-code")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "用户登录", -1)),
    _createVNode(_component_a_space, {
      class: "outer-tabs",
      direction: "vertical",
      size: "large"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          animation: true,
          justify: true,
          "lazy-load": true,
          "default-active-key": "1",
          size: "large",
          trigger: "hover",
          type: "rounded"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              class: "inner-tabs",
              title: "帐密登录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref_key: "formRef",
                  ref: formRef,
                  "label-align": 'right',
                  layout: _ctx.horizontal,
                  model: formAccPass,
                  rules: rulesAccPass,
                  "auto-label-width": "",
                  style: {"max-width":"480px","margin":"32px auto"},
                  onSubmit: handleSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      field: "userAccount",
                      label: "用户名",
                      tooltip: "用户名长度应不小于2",
                      "validate-trigger": "blur"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          modelValue: formAccPass.userAccount,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formAccPass.userAccount) = $event)),
                          "max-length": { length: 20, errorOnly: true },
                          "allow-clear": "",
                          placeholder: "请输入用户名",
                          "show-word-limit": ""
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(IconUser))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      field: "userPassword",
                      label: "密码",
                      tooltip: "密码长度应不小于8",
                      "validate-trigger": "blur"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_password, {
                          modelValue: formAccPass.userPassword,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formAccPass.userPassword) = $event)),
                          "allow-clear": "",
                          placeholder: "请输入密码"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(IconLock))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_a_link, {
                          href: "/user/forget",
                          style: {"width":"100px"}
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("忘记密码？ ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          "html-type": "submit",
                          style: {"width":"150px","margin":"0 auto"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode("登录 ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          style: {"width":"150px","margin":"0 auto"},
                          type: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/')))
                        }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createTextVNode("返回首页 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createTextVNode(" 未有账号？ ")),
                      _createVNode(_component_a_link, { href: "/user/register" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("点此注册")
                        ])),
                        _: 1
                      }),
                      _cache[12] || (_cache[12] = _createTextVNode(" ! "))
                    ])
                  ]),
                  _: 1
                }, 8, ["layout", "model"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              class: "inner-tabs",
              title: "验证码登录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  ref_key: "formRef",
                  ref: formRef,
                  "label-align": 'right',
                  layout: _ctx.horizontal,
                  model: formVerity,
                  rules: rulesVerity,
                  "auto-label-width": "",
                  style: {"max-width":"480px","margin":"32px auto"},
                  onSubmit: handleSubmitVerity
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      field: "userMail",
                      label: "邮箱",
                      tooltip: "用于获取验证码"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          modelValue: formVerity.userMail,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formVerity.userMail) = $event)),
                          placeholder: "example@mail.com"
                        }, {
                          prefix: _withCtx(() => [
                            _createVNode(_unref(IconEmail))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      field: "verityCode",
                      label: "验证码",
                      tooltip: "输入收到的验证码"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_verification_code, {
                          modelValue: formVerity.verityCode,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formVerity.verityCode) = $event)),
                          disabled: verityCodeProps.value.disabled,
                          error: verityCodeProps.value.error,
                          style: {"width":"300px"},
                          onFinish: onFinish
                        }, null, 8, ["modelValue", "disabled", "error"]),
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"16px"},
                          type: "primary",
                          onClick: getCode,
                          disabled: isVerityButtonDisabled.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isVerityButtonDisabled.value
                    ? `${coldDownTime.value}秒后可重发`
                    : "获取验证码"), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          "html-type": "submit",
                          style: {"width":"150px","margin":"0 auto"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("登录 ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          style: {"width":"150px","margin":"0 auto"},
                          type: "primary",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/')))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("返回首页 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _cache[16] || (_cache[16] = _createTextVNode(" 未有账号？ ")),
                      _createVNode(_component_a_link, { href: "/user/register" }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("点此注册")
                        ])),
                        _: 1
                      }),
                      _cache[17] || (_cache[17] = _createTextVNode(" ! "))
                    ])
                  ]),
                  _: 1
                }, 8, ["layout", "model"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "3",
              class: "inner-tabs",
              title: "微信扫码登录"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  size: "large",
                  style: {"margin":"32px auto"}
                }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", null, "请使用微信关注公众号进行登录", -1)),
                    _cache[20] || (_cache[20] = _createElementVNode("img", {
                      alt: "二维码",
                      src: _imports_0,
                      style: {"width":"256px"}
                    }, null, -1)),
                    _cache[21] || (_cache[21] = _createElementVNode("div", null, "发送“登录OJ”到微信公众号后台以获取验证码", -1)),
                    _createVNode(_component_a_form, {
                      ref_key: "formRef",
                      ref: formRef,
                      "label-align": 'right',
                      layout: _ctx.horizontal,
                      model: formVerity,
                      rules: rulesVerity,
                      "auto-label-width": "",
                      style: {"max-width":"480px","margin":"32px auto"},
                      onSubmit: handleSubmitVerity
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          field: "verityCode",
                          label: "验证码",
                          tooltip: "输入收到的验证码"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_verification_code, {
                              modelValue: formVerity.verityCode,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formVerity.verityCode) = $event)),
                              disabled: verityCodeProps.value.disabled,
                              error: verityCodeProps.value.error,
                              style: {"width":"300px"}
                            }, null, 8, ["modelValue", "disabled", "error"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              "html-type": "submit",
                              style: {"width":"150px","margin":"0 auto"},
                              type: "primary"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("登录 ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["layout", "model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})